import React, { useEffect } from 'react';
import {
  Form,
  FormInstance,
  SelectBooleanInput,
  NumberInput
} from '@lightbeamhealth/blueprint-form';
import { Row, Col } from '../../../../grid';
import { CardBlock } from '../../../organisms/card';
import Callout from '../../../organisms/callout';

interface EpxPedOncSettingsData {
  alerts?: boolean;
  missed?: number;
}

const DefaultSettings: EpxPedOncSettingsData = {
  alerts: true,
  missed: 1
};

interface EpxPedOncSettingsProps {
  setForm?: (form: FormInstance<EpxPedOncSettingsData>) => void;
  onSubmit?: (data: EpxPedOncSettingsData) => void;
  disabled?: boolean;
}

const EpxPedOncSettings = ({
  setForm,
  onSubmit: _onSubmit,
  disabled
}: EpxPedOncSettingsProps): JSX.Element => {
  const form = new FormInstance<EpxPedOncSettingsData>(DefaultSettings);
  useEffect(() => {
    if (setForm) {
      setForm(form);
    }
  }, []);
  const onChange = (data: EpxPedOncSettingsData): void => {
    form.setData(data);
  };
  const onSubmit = (data: EpxPedOncSettingsData): void => {
    _onSubmit(data);
  };
  return (
    <CardBlock bare>
      <Form form={form} onChange={onChange} onSubmit={onSubmit}>
        <CardBlock>
          <Row>
            <Col sm={12}>
              <SelectBooleanInput
                label="Enable Alerts for Patient"
                name="alerts"
                fill
                disabled={disabled}
              />
            </Col>
          </Row>
          <Row>
            <Col sm={12}>
              <NumberInput
                label="Alert for # of Consecutive Missed Doses"
                name="missed"
                min={1}
                required
                fill
                disabled={disabled}
              />
              <Callout>
                Note: This setting only applies to medications taken more than
                once per week. For weekly medications, an alert will trigger
                after missing the dose for a total of 3 days (the initial
                reminder and 2 consecutive reminders about that dose).
              </Callout>
            </Col>
          </Row>
        </CardBlock>
      </Form>
    </CardBlock>
  );
};

export default EpxPedOncSettings;
